const messages = {
  title: 'Napaka časovnega izteka dostopa',
  description: 'Zelo nam je žal zaradi nevšečnosti. Zdi se, da naš strežnik nekako ni prejel pravočasnega odziva.',
  backHomeButton: 'Nazaj na nadzorno ploščo'
}

export default {
  messages
}
